import React, {Component} from 'react'
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown'
import { injectIntl, intlShape } from 'react-intl'
import { fetchReservationTexts } from '../../redux/actions';
import get from 'lodash/get';

import ReservationForm from '../../components/ReservationForm'
import '../../components/ReservationForm.css';

class ReservationPage extends Component {
  constructor(props){
    super(props)
    this.state = {
      modalUrl: null,
      modalOpen: false,
	  showForm: false
    }
  }

  componentDidMount() {
    if (!this.props.reservationTexts) {
      this.props.fetchReservationTexts(this.props.intl.locale);
    }
  }

  render(){
    return(
      <div className="reservation-body container">
        <div style={{float:"none",width:"100%"}}>
          <h3>{this.props.intl.messages["general.bookTableHeader"]}</h3>
		  <a href={this.props.intl.locale==='fi' ? 'https://www.sevenrooms.com/reservations/levaingalleria' : 'https://www.sevenrooms.com/reservations/levaingalleria?lang=en'} target="_blank" className="btn btn_online_booking" rel="noopener noreferrer">Levain Galleria<br />{this.props.intl.messages["general.bookOnline"]}</a>
          <a href={this.props.intl.locale==='fi' ? 'https://www.sevenrooms.com/reservations/levainmerikortteli' : 'https://www.sevenrooms.com/reservations/levainmerikortteli?lang=en'} target="_blank" className="btn btn_online_booking" rel="noopener noreferrer">Levain Merikortteli<br />{this.props.intl.messages["general.bookOnline"]}</a>
          <a href={this.props.intl.locale==='fi' ? 'https://www.sevenrooms.com/reservations/levaintoolo' : 'https://www.sevenrooms.com/reservations/levaintoolo?lang=en'} target="_blank" className="btn btn_online_booking" rel="noopener noreferrer">Levain Töölö<br />{this.props.intl.messages["general.bookOnline"]}</a>
          <a href={this.props.intl.locale==='fi' ? 'https://www.sevenrooms.com/reservations/levainullanlinna' : 'https://www.sevenrooms.com/reservations/levainullanlinna?lang=en'} target="_blank" className="btn btn_online_booking" rel="noopener noreferrer">Levain Ullanlinna<br />{this.props.intl.messages["general.bookOnline"]}</a>
          <br />
		  
		  <a className="btn btn_inquiry" onClick={()=>this.setState({showForm: !this.state.showForm})}>{this.props.intl.messages["general.bookFormBtn"]}</a>
			
		  {this.state.showForm && (
			  <div className="reservation_form_container">
				  <ReservationForm />

				  {
					get(this.props, 'reservationTexts.groupReservationInfo') &&
					<ReactMarkdown source={get(this.props, 'reservationTexts.groupReservationInfo')} softBreak="br" />
				  }
			  </div>
		  )}
		  
          {
            get(this.props, 'reservationTexts.onlineBookingInfo') &&
            <ReactMarkdown source={get(this.props, 'reservationTexts.onlineBookingInfo')} softBreak="br" />
          }

        </div>
      </div>
    )
  }
}

ReservationPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  reservationTexts: state.reservationTexts,
});

const mapDispatchToProps = {
  fetchReservationTexts,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ReservationPage));


// WEBPACK FOOTER //
// ./src/containers/ContentPages/ReservationPage.js